// extracted by mini-css-extract-plugin
export var emailBlockLink = "_og-0";